// src/pages/RodoPage.jsx
export default function RodoPage() {
  return (
    <section className="section" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h1>Informacja RODO</h1>

      <p>
        Administratorem danych osobowych jest:
        <br /><br />
        <b>Art Rafał Tołczyk</b><br />
        ul. Boya-Żeleńskiego 2, 15-198 Białystok<br />
        kontakt: kontakt@arttolczyk.pl
      </p>

      <h2>Zakres i cele przetwarzania</h2>
      <p>
        Dane przetwarzane są wyłącznie w celu realizacji zamówień, kontaktu z
        klientem, obsługi reklamacji i celów księgowych.
      </p>

      <h2>Prawa klienta</h2>
      <ul>
        <li>dostęp do swoich danych</li>
        <li>prawo do poprawienia danych</li>
        <li>usunięcie danych</li>
        <li>ograniczenie przetwarzania</li>
        <li>skarga do Prezesa UODO</li>
      </ul>
    </section>
  );
}

